import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawBarMenuModule } from '@shared/core/components/drawBarMenu';
import { AccountDrawMenuComponent } from './account-draw-menu.shared.component';

@NgModule({
    declarations: [
        AccountDrawMenuComponent
    ],
    imports: [
        CommonModule,
        DrawBarMenuModule,
    ],
    exports: [
        AccountDrawMenuComponent
    ],
})
export class AccountDrawMenuModule { }
